module.exports = __webpack_public_path__ + "static/media/binary.f27bc414.png";